<div class="photographer-service" [style.--photographer-service-img-size.px]="imageSize">
  @if (service) {
    @if (getCoverImage()) {
      <app-image
        class="photographer-service__image"
        [imgClass]="'photographer-service__image-img'"
        [src]="getCoverImage()!"
        [alt]="service.name || 'Service'"
        preset="card"
        aspectRatio="1/1"
        [sizes]="imageSize + 'px'"
        [width]="imageSize"
        [height]="imageSize">
      </app-image>
    }

    <div class="photographer-service__info">
      <div class="photographer-service__info-title-section">
        <h2 class="photographer-service__info-title">{{service.name}}</h2>
        @if (hasDiscount()) {
          <p class="photographer-service__info-discount tag tag--green">-{{getDiscountValue()}}%</p>
        }
      </div>
      <div class="photographer-service__info-price">
        @if (hasPriceRange()) {
          @if (hasDiscount()) {
            <p class="photographer-service__info-details">
              {{'service.pricing.starting-at'|transloco}}
              <span class="old">{{getMinPublicPrice()|currency:'EUR'}}</span>
              <span class="new">{{getDiscountedPrice(getMinPublicPrice())|currency:'EUR'}}</span>
            </p>
          } @else {
            <p class="photographer-service__info-details">
              {{'service.pricing.starting-at'|transloco}}
              {{getMinPublicPrice()|currency:'EUR'}}
            </p>
          }
        } @else {
          @if (service && hasDiscount()) {
            <p class="photographer-service__info-details">
              <span class="old">{{getPublicPrice()|currency:'EUR'}}</span>
              <span class="new">{{getDiscountedPrice(getPublicPrice())|currency:'EUR'}}</span>
            </p>
          } @else {
            <p class="photographer-service__info-details">{{getPublicPrice()|currency:'EUR'}}</p>
          }
        }
      </div>
      <p class="photographer-service__info-description">{{service.description}}</p>
    </div>
  } @else {
    <div class="photographer-service__image skeleton-loading"></div>
    <div class="photographer-service__info">
      <h2 class="photographer-service__info-title skeleton-loading"></h2>
      <p class="photographer-service__info-details skeleton-loading"></p>
      <p class="photographer-service__info-description skeleton-loading"></p>
    </div>
  }

  <div class="photographer-service__arrow">
    <i class="fa-solid fa-chevron-right"></i>
  </div>
</div>
